module.exports = __webpack_public_path__ + "static/media/8.e8786d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/8.png
// module id = 508
// module chunks = 0